/**
 * Conditions under which the new guarantee step is skipped, regardless of the
 * slot/menu requiring `deposit` or `no_show`. Mirrors legacy setGuaranteeInfo
 * (meitre-frontend home.js:3030-3033):
 *
 *   1. Reschedule of an originally guaranteed reservation: the original
 *      guarantee is handled by the backend via `rescheduleId`, so the user
 *      isn't charged twice.
 *   2. Gift card redemption: the gift card covers the booking.
 *
 * Used in three places that must agree:
 *   - calculateFee.ts (returns a bypassed FeeBreakdown).
 *   - useBookingFlow.ts (drops `guaranteeFee` to 0 so the GUARANTEE step is
 *     filtered out by steps.ts).
 *   - ConfirmationPage.tsx (forces `effectiveGuaranteeType='traditional'`
 *     and clears any stale `feeDeposit` before submitting).
 */
export interface GuaranteeBypassInput {
  hasGiftCard: boolean;
  rescheduleOriginalType: string | null | undefined;
}

export function shouldBypassGuarantee({
  hasGiftCard,
  rescheduleOriginalType,
}: GuaranteeBypassInput): boolean {
  if (hasGiftCard) return true;
  if (!!rescheduleOriginalType && rescheduleOriginalType !== 'traditional') return true;
  return false;
}
